import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { TextArea } from "@progress/kendo-react-inputs";
import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { addTimeFunctionality } from "actions/time.action";
import { Label } from "@progress/kendo-react-labels";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import MattersCombobox from "../Postings/MattersComboBox";
import { useEffect } from "react";
import MatterDetails from "pages/MatterLedger/MatterDetails";
import { getMattersBalances } from "actions/matters.action";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { getMatterRates, editTimeRecord } from "api";
import { useActiveTimeTypes } from "services/timeTypeService";
import { Tooltip } from "@progress/kendo-react-tooltip";
import infoIcon from "../../assets/CaseFileIcons/info-icon.png";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useActiveFeeEarner } from "services/userService";
import { toast } from "react-toastify";
import MatterAccount from "components/MatterBalances/MatterBalances";
import styles from "./time.module.scss";

const AddTime = ({
  fromFeeEarner,
  fromCaseFile,
  mode = "add",
  initialData = null,
  ...props
}) => {
  const IS_MODAL = props.component === "modal";
  const dispatch = useDispatch();
  const date = new Date();
  const [details, setDetails] = useState("");
  const [units, setUnits] = useState(1);
  const [rateInfoText, setRateInfoText] = useState(0);
  const [mpu, setMpu] = useState(6);
  const [rate, setRate] = useState(0);
  const [value, setValue] = useState(0);
  const [dateselector, setdateselector] = useState(date);
  const [matterBalanceClear, setMatterBalanceClear] = useState(false);
  const [matterRef, setmatterref] = React.useState(
    IS_MODAL ? props.matter : null
  );
  const { data: feeEarnerData } = useActiveFeeEarner();
  const [feeearnerref, setfeeearnerref] = useState(
    props.matter &&
      props?.matter?.feeEarnerRef && {
        userRef: props?.matter?.feeEarnerRef,
        display: `${props?.matter?.feeEarnerRef} - ${props?.matter?.feeEarnerName}`,
      }
  );
  const [error, setError] = useState(undefined);
  const { data: timetypes, loading } = useActiveTimeTypes();
  const [type, settype] = useState();

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setDetails(initialData.details || "");
      setUnits(initialData.units || 1);
      setMpu(initialData.mpu || 6);
      setRate(initialData.rate || 0);
      setValue(initialData.value || 0);
      setdateselector(new Date(initialData.date));
      settype({
        name: initialData.timeTypeName,
        timeTypeID: initialData.timeTypeId,
      });
      setmatterref({
        matterId: initialData.matterId,
        matterRef: initialData.matterRef,
      });
      setfeeearnerref(
        feeEarnerData?.find(
          (feeEarner) => feeEarner.userRef === initialData.feeEarnerRef
        )
      );
    }
  }, [mode, initialData]);

  const onChangematter = (event) => {
    setMatterBalanceClear(false);
    if (event.value !== null && event.value !== undefined) {
      setmatterref(event.value);
      if (event?.value?.feeEarnerRef) {
        setfeeearnerref({
          userRef: event?.value?.feeEarnerRef,
        });
      } else {
        setfeeearnerref(null);
      }
      dispatch(getMattersBalances(event?.value?.matterId, "Time Recording"));
    } else {
      setMatterBalanceClear(true);
      setfeeearnerref();
    }
  };
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };
  const onChangefeeearner = (event) => {
    setfeeearnerref(event.value);
  };

  const onChangetimetype = (event) => {
    settype(event.value);
  };
  const calculateValue = useCallback(() => {
    const numericRate = Number(rate) || 0;
    const numericUnits = Number(units) || 0;
    const numericMpu = Number(mpu) || 0;

    if (numericRate > 0 && numericUnits > 0 && numericMpu > 0) {
      const calculated = (numericRate / 60) * (numericUnits * numericMpu);
      setValue(calculated);
    } else {
      setValue(0);
    }
  }, [rate, units, mpu]);
  useEffect(() => {
    calculateValue();
  }, [calculateValue]);

  const getMatterRateValue = useCallback(async () => {
    try {
      const data = await getMatterRates(
        matterRef?.matterId,
        feeearnerref.userRef
      );
      setRate(data?.data?.data?.rateValue);
      setRateInfoText(data?.data?.data?.rateInfo);
    } catch (error) {}
  }, [matterRef?.matterId, feeearnerref?.userRef]);

  useEffect(() => {
    if (matterRef && feeearnerref) getMatterRateValue();
  }, [matterRef, feeearnerref, getMatterRateValue]);

  async function handleSubmit(e) {
    e.preventDefault();

    const isEdit = mode === "edit";
    const payload = {
      timeId: isEdit ? initialData?.timeId : 0,
      matterId: matterRef?.matterId || props.matter?.matterId,
      feeEarnerRef: feeearnerref?.userRef,
      date: dateselector,
      details,
      units,
      mpu,
      rate,
      value,
      timeTypeId: type?.timeTypeID,
    };

    // Validation
    const hasError =
      !payload.matterId ||
      details.trim() === "" ||
      !units ||
      !rate ||
      !value ||
      !payload.timeTypeId;

    if (hasError) {
      setError(true);

      if (!payload.matterId) toast.error("Please select a Matter.");
      else if (details.trim() === "") toast.error("Please enter details.");
      else if (!units) toast.error("Please enter valid units.");
      else if (!rate) toast.error("Rate cannot be 0.");
      else if (!value) toast.error("Calculated value is missing.");
      else if (!payload.timeTypeId) toast.error("Please select a Time Type.");

      return;
    }

    const onSuccess = () => {
      if (props.fetchTime) props.fetchTime();
      if (fromCaseFile) props.showModal();
      else if (IS_MODAL) props.cancelEdit();
      reset();
    };

    try {
      if (isEdit) {
        await editTimeRecord([payload]);
        toast.success("Time entry updated successfully.");
        onSuccess();
      } else {
        dispatch(addTimeFunctionality([payload], onSuccess));
      }
    } catch (err) {
      console.error("Error submitting time:", err);
      toast.error("An error occurred while saving the time entry.");
    }
  }

  const reset = () => {
    setError(undefined);
    setDetails("");
    setValue(0);
    setMpu(6);
    setUnits(1);
    setRate(0);
  };

  const handleCancel = () => {
    if (fromCaseFile) {
      props.showModal();
    } else reset();
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        height: fromFeeEarner ? "100vh" : "calc(100% - 65px)",
      }}
    >
      <div
        className={`${
          fromFeeEarner ? "vh-100" : "mx-lg-5 mx-1 h-100"
        } d-flex justify-content-center`}
      >
        <div className="bgForm overflow-auto">
          <div
            className="px-lg-5 px-3 "
            style={{
              maxHeight: fromFeeEarner ? "calc(100vh - 130px)" : "auto",
              overflow: "auto",
            }}
          >
            <div className="d-flex mt-3">
              <div
                className={`d-flex flex-column me-5
                ${fromFeeEarner ? "mt-5" : ""}
                `}
              >
                <div>
                  <Label className="label mb-1 d-block">Matter</Label>
                  <MattersCombobox
                    width={280}
                    onChangematter={onChangematter}
                    error={error === true && matterRef === undefined}
                    value={matterRef}
                    disabled={props.matter}
                  />
                </div>
                <div className="mt-2">
                  <Label className="label mb-1 d-block">Date</Label>
                  <DatePicker
                    className="datepicker px-2"
                    toggleButton={CalenderCustomToggleButton}
                    value={dateselector}
                    onChange={onChangedateselect}
                  />
                </div>
                <div className="mt-2">
                  <Label className="label mb-1 d-block">Time Type</Label>
                  <ComboBox
                    style={{
                      textAlign: "end",
                      border: error === true && !type && "1px solid red",
                      width: "280px",
                    }}
                    data={timetypes}
                    loading={loading}
                    textField={`name`}
                    iconClassName="wa"
                    filterable={true}
                    placeholder={"Add Time Type"}
                    value={type}
                    onChange={onChangetimetype}
                  />
                </div>
                <Label className="label mb-1 d-block mt-2">Fee Earner</Label>
                <ComboBox
                  style={{
                    width: "280px",
                    border:
                      error === true &&
                      (feeearnerref === null || feeearnerref === undefined) &&
                      "1px solid red",
                  }}
                  data={feeEarnerData}
                  textField={`display`}
                  iconClassName="wa"
                  filterable={true}
                  placeholder={"Search Fee Earner"}
                  value={feeearnerref}
                  onChange={onChangefeeearner}
                />
              </div>

              <div>
                <div>
                  <MatterDetails
                    matter={matterRef}
                    clear={matterBalanceClear}
                  />
                </div>
                <div className="mt-3">
                  <MatterAccount
                    matterId={matterRef?.matterId || props.matter?.matterId}
                    component="Time Recording"
                    clear={matterBalanceClear}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex  mt-2">
              <div className="d-flex  align-items-end me-5">
                <div className="d-flex flex-column me-3 ">
                  <Label className="label mb-1 d-block">Units</Label>
                  <NumericTextBox
                    type={"number"}
                    value={units}
                    onChange={(e) => {
                      const units = Number(e.target.value || 1);
                      setUnits(units);
                    }}
                    min={1}
                    style={{
                      width: "130px",
                    }}
                    onKeyDown={(e) => {
                      if (e.key === ".") {
                        return e.preventDefault();
                      }
                    }}
                  />
                </div>

                <div className="d-flex">
                  <div className="d-flex flex-column right-align">
                    <div className="d-flex align-items-baseline ">
                      <Label className="label mb-1 d-block">Rate</Label>
                      <Tooltip anchorElement="target" position="top">
                        <img
                          src={infoIcon}
                          title={rateInfoText}
                          className="ms-1  cursor-pointer"
                          style={{
                            height: "14px",
                            width: "14px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <NumericTextBox
                      style={{
                        textAlign: "end",
                        border: error === true && rate === 0 && "1px solid red",
                        width: "130px",
                      }}
                      width={90}
                      step={0}
                      spinners={false}
                      format={"n2"}
                      type={"number"}
                      value={rate}
                      onKeyDown={(e) => {
                        if (e.key === ".") {
                          return e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const rate = Number(e.target.value || 0);
                        setRate(rate);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column right-align  ">
                <div className="d-flex align-items-baseline ">
                  <Label className="label mb-1 d-block">Value</Label>
                  <Tooltip anchorElement="target" position="top">
                    <img
                      className="ms-1 cursor-pointer"
                      src={infoIcon}
                      title={"MPU is equal to 6"}
                      style={{
                        height: "14px",
                        width: "14px",
                      }}
                    />
                  </Tooltip>
                </div>
                <NumericTextBox
                  width={280}
                  style={{ textAlign: "right" }}
                  value={value}
                  readOnly={true}
                  placeholder="0.00"
                  spinners={false}
                  format="n2"
                />
              </div>
            </div>

            <div className="d-flex my-2 flex-column">
              <Label className="label mb-1 ">Details</Label>
              <TextArea
                value={details}
                style={{
                  height: 50,
                  textAlign: "start",
                  maxWidth: "100%",
                  width: "100%",
                  border: error === true && details === "" && "1px solid red",
                }}
                rows={5}
                multiple={true}
                placeholder="Enter Details"
                onChange={(e) => {
                  setDetails(e.target.value);
                }}
              />
            </div>
            {fromFeeEarner && (
              <div>
                <div className={`d-flex float-end mt-5`}>
                  <Button
                    className="common-btn bgBtnSecondary me-3"
                    type="button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="common-btn "
                    type="submit"
                    id="time-recording-submit"
                  >
                    Post
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={styles.action_btn}
        style={{
          height: "65px",
        }}
      >
        {!fromFeeEarner && (
          <DialogActionsBar>
            <div className={`d-flex float-end dialog-footer w-100`}>
              <Button
                className="common-btn bgBtnSecondary me-3"
                type="button"
                onClick={props.cancelEdit}
              >
                Cancel
              </Button>
              <Button
                className="common-btn me-4"
                type="submit"
                id="time-recording-submit"
              >
                Post
              </Button>
            </div>
          </DialogActionsBar>
        )}
      </div>
    </form>
  );
};
export default AddTime;
